<script>
import TraitEditor from './TraitEditor'
import UUID from 'uuid/v4'

export default {

  components: {
    TraitEditor
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      internalValue: this.value,
    }
  },

  watch: {
    internalValue() {
      this.$emit('input', this.internalValue)
    }
  },

  computed: {
    traits() {
      return Object.values(this.internalValue)
    }
  },

  methods: {
    addNewTrait() {
      let uuid = UUID()
      this.$set(this.internalValue, uuid, {
        "name": "New Trait",
        "uuid": uuid,
        "params": {}
      })
    }
  }

}
</script>

<template>
  <div>
    <div v-for="trait in traits" :key="trait.uuid">
      <trait-editor :trait="trait"></trait-editor>
      <br>
    </div>

    <b-button icon-left="plus" @click="addNewTrait">
      Add trait
    </b-button>
  </div>
</template>

<style lang="scss">

</style>